/*
 * @Description: 季度个人盈利看板
 * @Author: 杨志航
 * @Date: 2026-09-07 14:34:29
 */
import React, { useState, useEffect } from 'react'
import api from 'api'
import {
  Table,
  Form,
  Select,
  Input,
  InputNumber,
  Button,
  Alert,
} from 'antd'
import { allTrim, filterParams } from '@/utils'

const { Column } = Table
const FormItem = Form.Item
const Option = Select.Option
const quarterOptions = [
  { label: 'Q1', value: '1' },
  { label: 'Q2', value: '2' },
  { label: 'Q3', value: '3' },
  { label: 'Q4', value: '4' },
]
const currentYear = new Date().getFullYear()
const yearOptions = Array.from({ length: currentYear - 2025 }, (_, index) => {
  const year = 2026 + index
  return { label: String(year), value: String(year) }
})
const isLiveList = [{
  name: '是',
}, {
  name: '否',
}]

let pageSize = 10
let currentPage = 1
let searchParams = {
  limit: pageSize, 
  page: currentPage
}

const Quarterly = props => {
  const { getFieldDecorator, validateFields, resetFields, setFieldsValue, getFieldsValue, getFieldValue } = props.form
  const [count, setCount] = useState(0)
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const [companyList, setCompanyList] = useState([])
  const [groupList, setGroupList] = useState([])
  const [departmentTypeList, setDepartmentTypeList] = useState([])
  const [personalAttrList, setPersonalAttrList] = useState([])

  useEffect(() => {
    resetParams()
    getList()
    getSearchData()
  }, [])
  //获取检索所需数据
  const getSearchData =  () => {
    api.getProfitReportSearchData().then(res => {
      const { departmentType, personalAttr } = res
      setDepartmentTypeList(departmentType)
      setPersonalAttrList(personalAttr)
    })
    api.getGroupDepartList().then(data => {
      setGroupList(data)
    })
    api.getSelectCompanyList({ limit: global.paramsLimit }).then(data => {
      setCompanyList(data.list)
    })
  }

  const resetParams = () => {
    searchParams = {
      limit: pageSize, 
      page: currentPage
    }
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    }
  }

  //获取列表
  const getList = () => {
    setLoading(true)
    api.getProfitReportQuarterlyList(searchParams).then(res => {
      const { list, count } = res
      setList(list)
      setCount(count)
      setLoading(false)
    }).catch(() => { setLoading(false) })
  }

  //重置
  const onReset = () => {
    resetFields()
    currentPage = 1
    resetParams()
    getList()
  }
  //提交
  const formSubmit = evt => {
    evt.preventDefault()
    setFieldsValue(allTrim(getFieldsValue()))
    validateFields((err, vals) => {
      if (!err) {
        vals = filterParams(vals)
        if (vals.quarterlyYear && vals.quarterlyQuarter) {
          vals.quarterly = `${vals.quarterlyYear}-Q${vals.quarterlyQuarter}`
        }
        delete vals.quarterlyYear
        delete vals.quarterlyQuarter
        currentPage = 1
        resetParams()
        searchParams = {...searchParams, ...vals}
        getList()
      }
    })
  }
  //点击分页
  const onChangeTable = (pagination, filters, sorter) => {
    searchParams.page = currentPage = pagination.current
    searchParams.limit = pageSize = pagination.pageSize
    getList()
  }

  const onChangeQuarterly = (value, field) => {
    if (value) {
      if (!getFieldValue(field)) {
        setFieldsValue({
          [field]: field === 'quarterlyQuarter' ? quarterOptions[0].value : yearOptions[0].value
        })
      }
    } else {
      setFieldsValue({
        [field]: undefined
      })
    }
  }

  return (
   <>
    <div className="search-doc-wrap">
      <Form onSubmit={formSubmit}  {...formItemLayout}>
        <div className="form-box">
          <FormItem label="员工姓名">
            {getFieldDecorator('staffName')(<Input placeholder="请输入员工姓名" />)}
          </FormItem>
          <FormItem label="员工编号">
            {getFieldDecorator('staffNo')(<InputNumber placeholder="请输入员工编号" style={{ width: '100%'}} />)}
          </FormItem>
          <FormItem label="员工属性">
            {getFieldDecorator('personalAttr')(<Select 
              placeholder="请选择"
              allowClear
            >
              {
                personalAttrList.map((item, index) => <Option key={index} value={item.name}>{item.name}</Option>)
              }
            </Select>)}
          </FormItem>
          <FormItem label="季度">
            <div style={{ display: 'flex', gap: 8 }}>
              <FormItem style={{ marginBottom: 0, flex: 1 }}>
                {getFieldDecorator('quarterlyYear')(
                  <Select 
                    placeholder="年份" 
                    allowClear 
                    style={{ width: '100%' }}
                    onChange={value => onChangeQuarterly(value, 'quarterlyQuarter')}
                  >
                    {yearOptions.map(item => (
                      <Option key={item.value} value={item.value}>{item.label}</Option>
                    ))}
                  </Select>
                )}
              </FormItem>
              <FormItem style={{ marginBottom: 0, flex: 1 }}>
                {getFieldDecorator('quarterlyQuarter')(
                  <Select 
                    placeholder="季度" 
                    allowClear 
                    style={{ width: '100%' }}
                    onChange={value => onChangeQuarterly(value, 'quarterlyYear')}
                  >
                    {quarterOptions.map(item => (
                      <Option key={item.value} value={item.value}>{item.label}</Option>
                    ))}
                  </Select>
                )}
              </FormItem>
            </div>
          </FormItem>
          <FormItem label="主体">
            {getFieldDecorator('companyId')(<Select 
              placeholder="请选择"
              allowClear
              showSearch
              optionFilterProp="children"
            >
              {
                companyList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
              }
            </Select>)}
          </FormItem>
          <FormItem label="事业群">
            {getFieldDecorator('groupId')(<Select 
              placeholder="请选择"
              allowClear
              showSearch
              optionFilterProp="children"
            >
              {
                groupList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
              }
            </Select>)}
          </FormItem>
          <FormItem label="部门">
            {getFieldDecorator('departmentName')(<Input placeholder="请输入部门" />)}
          </FormItem>
          <FormItem label="部门类型">
            {getFieldDecorator('departmentType')(<Select 
              placeholder="请选择"
              allowClear
            >
              {
                departmentTypeList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
              }
            </Select>)}
          </FormItem>
          <FormItem label="电商门店直播">
            {getFieldDecorator('isLive')(<Select 
              placeholder="请选择"
              allowClear
            >
              {
                isLiveList.map((item, index) => <Option key={index} value={item.name}>{item.name}</Option>)
              }
            </Select>)}
          </FormItem>
        </div>
        <FormItem className="btns" label=" " colon={false}>
          <Button type="primary" htmlType="submit">查询</Button>
          <Button onClick={onReset}>重置</Button>
        </FormItem>
      </Form>
    </div>
    <div className="line"></div>
    <div>
      <Alert className="corp-count" message={`总计：${count}条数据`} type="info" showIcon />
      <Table
        size="small"
        dataSource={list}
        rowKey="id"  
        loading={loading}
        scroll={{ x: 'max-content' }}
        pagination={{
          pageSize,
          total: count,
          current: currentPage,
          showQuickJumper: true,
          showSizeChanger: true,
          pageSizeOptions: ['10', '50', '100', '500', '1000', '2000']
        }}
        onChange={onChangeTable}
        rowClassName={record => {
          const { personalNetProfit, achResult } = record
          let rowClassName = ''
          if (personalNetProfit !== '' || achResult !== '') {
            rowClassName = (record.personalNetProfit > 0 || parseFloat(record.achResult) === 100) ? 'table-row-blue' : 'table-row-red'
          }
          return rowClassName
        }}
      >
        <Column title="季度" dataIndex="quarterly" fixed="left" />
        <Column title="员工编号" dataIndex="staffNo" fixed="left" />
        <Column title="员工姓名" dataIndex="staffName" fixed="left" />
        <Column title="事业群名称" dataIndex="groupName" />
        <Column title="部门名称" dataIndex="departmentName" />
        <Column title="部门类型" dataIndex="departmentType" />
        <Column title="所属主体" dataIndex="companyName" />     
        <Column title="员工属性" dataIndex="personalAttr" />
        <Column title="电商门店直播" dataIndex="isLive" />
        <Column title="人员成本(元)" dataIndex="personalCost" />
        <Column title="订单利润(元)" dataIndex="orderProfit" />
        <Column 
          title="个人净利一(元)" 
          dataIndex="personalNetProfit" 
          render={(text, record) =>(
            <span style={{ color: record.personalNetProfit > 0 ? '#1890ff' : 'red' }}>{text}</span>
          )}
        />
        <Column 
          title="贡献率" 
          dataIndex="contributionRate" 
          render={(text, record) =>(
            <span style={{ color: record.personalNetProfit > 0 ? '#1890ff' : 'red' }}>{text}</span>
          )}
        />
        <Column 
          title="绩效" 
          dataIndex="achResult" 
          render={(text, record) =>(
            <span style={{ color: parseFloat(text) >= 100 ? '#1890ff' : 'red' }}>{text}</span>
          )}
        />
      </Table>
    </div>
   </> 
  )
}

export default Form.create()(Quarterly)
